import React from "react";
import { Route, Routes, useParams } from "react-router-dom";
import AdminLayout from "../../components/Layout";
import Dashboard from "../../screens/dashboard";
import CreateJob from "../../screens/jobs/create";
import JobsCreated from "../../screens/jobs/dashboard";
import InterviewReports from "../../screens/jobs/reports[id]";
import CandidateCreate from "../../screens/candidates/create";
import InterviewCandidates from "../../screens/candidates/dashboard[id]";
import CreateCandidateBulk from "../../screens/candidates/create-bulk";
import CreateQuestions from "../../screens/pretest-assessment/pretest";
import EditJobForm from "../../screens/jobs/edit/[id]";
import Subscriptions from "../../screens/subscription";
import RenewSubscription from "../../screens/subscription/renew";
import UpgradeSubscription from "../../screens/subscription/upgrade";
import Profile from "../../screens/settings/profile";
import CreateAdmin from "../../screens/settings/admins/create";
import AdminMain from "../../screens/settings/admins/dashboard";
import ChangePassword from "../../screens/settings/change-password";
import CreateQuestionsAssessment from "../../screens/pretest-assessment/assessment";
import CandidateHomepage from "../../screens/candidates/home";
import InterviewsView from "../../screens/jobs/interviews";
import PretestTable from "../../screens/pretest-assessment/pretests";
import AssessmentsTable from "../../screens/pretest-assessment/assessments";
import RequestDemoAdmins from "../../screens/settings/requests-demo";
import CompanyProfile from "../../screens/settings/requests-demo/view[id]/ViewRequests";
import AgreementsPage from "../../screens/agreements";
import BulkPostOnboard from "../../screens/agreements/BulkPostOnboard";
import PaymentSelection from "../../screens/payment/payment-selection";
import Documents from "../../screens/documents";
import CreatePlan from "../../screens/settings/plans/CreatePlan";
import CreateAddon from "../../screens/settings/addons/CreateAddon";
import OfferingsDashboard from "../../screens/settings/offerings/OfferingsDashboard";
import OnboardingClientsList from "../../screens/onboarding-clients";
import OnboardingClientDetailsView from "../../screens/onboarding-clients/view[id]";
// import PricingPage from "../../screens/pricing";
// import TermsAcceptance from "../../screens/terms";
// import MakePayment from "../../screens/pricing/pay";

// Wrapper component to extract ID from URL params
const EditJobWrapper: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  if (!id) {
    return <div>Job ID not found</div>;
  }
  return <EditJobForm jobId={id} />;
};

const EditPretestWrapper: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  return <CreateQuestions mode="edit" id={id} />;
};

const EditAssessmentWrapper: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  return <CreateQuestionsAssessment mode="edit" id={id} />;
};

const AuthRoutes: React.FC = () => {
  return (
    <AdminLayout>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/create-job" element={<CreateJob />} />
        <Route path="/jobs" element={<JobsCreated />} />
        <Route path="/edit-job/:id" element={<EditJobWrapper />} />
        <Route path="/interviews" element={<InterviewsView />} />
        <Route path="/reports" element={<InterviewReports />} />
        <Route path="/create-interview" element={<CandidateCreate />} />
        <Route path="/edit-candidate" element={<CandidateCreate />} />
        <Route path="/interviews/:id" element={<InterviewCandidates />} />
        <Route
          path="/create-bulk-candidates"
          element={<CreateCandidateBulk />}
        />
        <Route path="/pretest-create" element={<CreateQuestions />} />
        <Route path="/pretest/edit/:id" element={<EditPretestWrapper />} />
        <Route
          path="/assessment-create"
          element={<CreateQuestionsAssessment />}
        />
        <Route
          path="/assessment/edit/:id"
          element={<EditAssessmentWrapper />}
        />
        <Route path="/pretests" element={<PretestTable />} />
        <Route path="/assessments" element={<AssessmentsTable />} />
        <Route path="/candidates" element={<CandidateHomepage />} />
        <Route path="/subscriptions" element={<Subscriptions />} />
        <Route path="/subscriptions/renew" element={<RenewSubscription />} />
        <Route
          path="/subscriptions/upgrade"
          element={<UpgradeSubscription />}
        />
        <Route path="settings/profile" element={<Profile />} />
        <Route path="settings/admin/create" element={<CreateAdmin />} />
        <Route path="settings/admin" element={<AdminMain />} />
        <Route path="settings/change-password" element={<ChangePassword />} />
        <Route path="/admins" element={<RequestDemoAdmins />} />
        <Route path="/admins/show/:id" element={<CompanyProfile />} />
        <Route path="/agreements" element={<AgreementsPage />} />
        <Route path="/admin/bulk-post-onboard" element={<BulkPostOnboard />} />
        {/* <Route path="/pricing/:id" element={<PricingPage />} />
        <Route path="/terms/:id" element={<TermsAcceptance />} />
        <Route path="/pricing/pay/:id" element={<MakePayment />} /> */}
        <Route path="/payment-selection" element={<PaymentSelection />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/admin/plans/create" element={<CreatePlan />} />
        <Route path="/admin/addons/create" element={<CreateAddon />} />
        <Route path="/onboarding-clients" element={<OnboardingClientsList />} />
        <Route path="/onboarding-clients/:id" element={<OnboardingClientDetailsView />} />
        <Route path="/admin/offerings" element={<OfferingsDashboard />} />
      </Routes>
    </AdminLayout>
  );
};


export default AuthRoutes;
